export default {
  title: 'Login with SSO',
  subtitle: 'Enter your company email to continue with Single Sign-On',
  continueButton: 'Continue with SSO',
  errors: {
    noSsoConfiguration:
      'No SSO configuration found for this email domain. Please contact your administrator.'
  }
};
